export const kota = [
    {
        id: 1,
        state_id: 1,
        name: "Aceh Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 2,
        state_id: 1,
        name: "Aceh Barat Daya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 3,
        state_id: 1,
        name: "Aceh Besar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 4,
        state_id: 1,
        name: "Aceh Jaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 5,
        state_id: 1,
        name: "Aceh Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 6,
        state_id: 1,
        name: "Aceh Singkil",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 7,
        state_id: 1,
        name: "Aceh Tamiang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 8,
        state_id: 1,
        name: "Aceh Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 9,
        state_id: 1,
        name: "Aceh Tenggara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 10,
        state_id: 1,
        name: "Aceh Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 11,
        state_id: 1,
        name: "Aceh Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 12,
        state_id: 1,
        name: "Banda Aceh",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 13,
        state_id: 1,
        name: "Bener Meriah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 14,
        state_id: 1,
        name: "Bireuen",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 15,
        state_id: 1,
        name: "Gayo Lues",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 16,
        state_id: 1,
        name: "Langsa",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 17,
        state_id: 1,
        name: "Lhokseumawe",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 18,
        state_id: 1,
        name: "Nagan Raya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 19,
        state_id: 1,
        name: "Pidie",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 20,
        state_id: 1,
        name: "Pidie Jaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 21,
        state_id: 1,
        name: "Sabang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 22,
        state_id: 1,
        name: "Simeulue",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 23,
        state_id: 1,
        name: "Subulussalam",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 24,
        state_id: 2,
        name: "Badung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 25,
        state_id: 2,
        name: "Bangli",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 26,
        state_id: 2,
        name: "Buleleng",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 27,
        state_id: 2,
        name: "Denpasar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 28,
        state_id: 2,
        name: "Gianyar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 29,
        state_id: 2,
        name: "Jembrana",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 30,
        state_id: 2,
        name: "Karangasem",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 31,
        state_id: 2,
        name: "Klungkung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 32,
        state_id: 2,
        name: "Tabanan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 33,
        state_id: 3,
        name: "Cilegon",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 34,
        state_id: 3,
        name: "Lebak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 35,
        state_id: 3,
        name: "Pandeglang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 36,
        state_id: 3,
        name: "Serang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 37,
        state_id: 3,
        name: "Tangerang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 38,
        state_id: 3,
        name: "Tangerang Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 39,
        state_id: 4,
        name: "Bengkulu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 40,
        state_id: 4,
        name: "Bengkulu Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 41,
        state_id: 4,
        name: "Bengkulu Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 42,
        state_id: 4,
        name: "Bengkulu Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 43,
        state_id: 4,
        name: "Kaur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 44,
        state_id: 4,
        name: "Kepahiang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 45,
        state_id: 4,
        name: "Lebong",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 46,
        state_id: 4,
        name: "Muko Muko",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 47,
        state_id: 4,
        name: "Rejang Lebong",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 48,
        state_id: 4,
        name: "Seluma",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 49,
        state_id: 5,
        name: "Bantul",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 50,
        state_id: 5,
        name: "Gunung Kidul",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 51,
        state_id: 5,
        name: "Kulon Progo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 52,
        state_id: 5,
        name: "Sleman",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 53,
        state_id: 5,
        name: "Yogyakarta",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 54,
        state_id: 6,
        name: "Jakarta Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 55,
        state_id: 6,
        name: "Jakarta Pusat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 56,
        state_id: 6,
        name: "Jakarta Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 57,
        state_id: 6,
        name: "Jakarta Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 58,
        state_id: 6,
        name: "Jakarta Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 59,
        state_id: 6,
        name: "Kepulauan Seribu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 60,
        state_id: 7,
        name: "Boalemo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 61,
        state_id: 7,
        name: "Bone Bolango",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 62,
        state_id: 7,
        name: "Gorontalo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 63,
        state_id: 7,
        name: "Gorontalo Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 64,
        state_id: 7,
        name: "Pohuwato",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 65,
        state_id: 8,
        name: "Batang Hari",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 66,
        state_id: 8,
        name: "Bungo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 67,
        state_id: 8,
        name: "Jambi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 68,
        state_id: 8,
        name: "Kerinci",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 69,
        state_id: 8,
        name: "Merangin",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 70,
        state_id: 8,
        name: "Muaro Jambi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 71,
        state_id: 8,
        name: "Sarolangun",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 72,
        state_id: 8,
        name: "Sungaipenuh",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 73,
        state_id: 8,
        name: "Tanjung Jabung Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 74,
        state_id: 8,
        name: "Tanjung Jabung Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 75,
        state_id: 8,
        name: "Tebo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 76,
        state_id: 9,
        name: "Bandung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 77,
        state_id: 9,
        name: "Bandung Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 78,
        state_id: 9,
        name: "Banjar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 79,
        state_id: 9,
        name: "Bekasi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 80,
        state_id: 9,
        name: "Bogor",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 81,
        state_id: 9,
        name: "Ciamis",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 82,
        state_id: 9,
        name: "Cianjur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 83,
        state_id: 9,
        name: "Cimahi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 84,
        state_id: 9,
        name: "Cirebon",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 85,
        state_id: 9,
        name: "Depok",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 86,
        state_id: 9,
        name: "Garut",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 87,
        state_id: 9,
        name: "Indramayu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 88,
        state_id: 9,
        name: "Karawang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 89,
        state_id: 9,
        name: "Kuningan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 90,
        state_id: 9,
        name: "Majalengka",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 91,
        state_id: 9,
        name: "Pangandaran",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 92,
        state_id: 9,
        name: "Purwakarta",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 93,
        state_id: 9,
        name: "Subang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 94,
        state_id: 9,
        name: "Sukabumi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 95,
        state_id: 9,
        name: "Sumedang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 96,
        state_id: 9,
        name: "Tasikmalaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 97,
        state_id: 10,
        name: "Banjarnegara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 98,
        state_id: 10,
        name: "Banyumas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 99,
        state_id: 10,
        name: "Batang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 100,
        state_id: 10,
        name: "Blora",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 101,
        state_id: 10,
        name: "Boyolali",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 102,
        state_id: 10,
        name: "Brebes",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 103,
        state_id: 10,
        name: "Cilacap",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 104,
        state_id: 10,
        name: "Demak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 105,
        state_id: 10,
        name: "Grobogan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 106,
        state_id: 10,
        name: "Jepara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 107,
        state_id: 10,
        name: "Karanganyar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 108,
        state_id: 10,
        name: "Kebumen",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 109,
        state_id: 10,
        name: "Kendal",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 110,
        state_id: 10,
        name: "Klaten",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 111,
        state_id: 10,
        name: "Kudus",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 112,
        state_id: 10,
        name: "Magelang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 113,
        state_id: 10,
        name: "Pati",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 114,
        state_id: 10,
        name: "Pekalongan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 115,
        state_id: 10,
        name: "Pemalang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 116,
        state_id: 10,
        name: "Purbalingga",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 117,
        state_id: 10,
        name: "Purworejo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 118,
        state_id: 10,
        name: "Rembang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 119,
        state_id: 10,
        name: "Salatiga",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 120,
        state_id: 10,
        name: "Semarang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 121,
        state_id: 10,
        name: "Sragen",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 122,
        state_id: 10,
        name: "Sukoharjo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 123,
        state_id: 10,
        name: "Surakarta",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 124,
        state_id: 10,
        name: "Tegal",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 125,
        state_id: 10,
        name: "Temanggung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 126,
        state_id: 10,
        name: "Wonogiri",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 127,
        state_id: 10,
        name: "Wonosobo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 128,
        state_id: 11,
        name: "Bangkalan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 129,
        state_id: 11,
        name: "Banyuwangi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 130,
        state_id: 11,
        name: "Batu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 131,
        state_id: 11,
        name: "Blitar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 132,
        state_id: 11,
        name: "Bojonegoro",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 133,
        state_id: 11,
        name: "Bondowoso",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 134,
        state_id: 11,
        name: "Gresik",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 135,
        state_id: 11,
        name: "Jember",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 136,
        state_id: 11,
        name: "Jombang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 137,
        state_id: 11,
        name: "Kediri",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 138,
        state_id: 11,
        name: "Lamongan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 139,
        state_id: 11,
        name: "Lumajang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 140,
        state_id: 11,
        name: "Madiun",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 141,
        state_id: 11,
        name: "Magetan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 142,
        state_id: 11,
        name: "Malang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 143,
        state_id: 11,
        name: "Mojokerto",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 144,
        state_id: 11,
        name: "Nganjuk",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 145,
        state_id: 11,
        name: "Ngawi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 146,
        state_id: 11,
        name: "Pacitan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 147,
        state_id: 11,
        name: "Pamekasan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 148,
        state_id: 11,
        name: "Pasuruan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 149,
        state_id: 11,
        name: "Ponorogo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 150,
        state_id: 11,
        name: "Probolinggo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 151,
        state_id: 11,
        name: "Sampang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 152,
        state_id: 11,
        name: "Sidoarjo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 153,
        state_id: 11,
        name: "Situbondo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 154,
        state_id: 11,
        name: "Sumenep",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 155,
        state_id: 11,
        name: "Surabaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 156,
        state_id: 11,
        name: "Trenggalek",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 157,
        state_id: 11,
        name: "Tuban",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 158,
        state_id: 11,
        name: "Tulungagung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 159,
        state_id: 12,
        name: "Bengkayang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 160,
        state_id: 12,
        name: "Kapuas Hulu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 161,
        state_id: 12,
        name: "Kayong Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 162,
        state_id: 12,
        name: "Ketapang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 163,
        state_id: 12,
        name: "Kubu Raya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 164,
        state_id: 12,
        name: "Landak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 165,
        state_id: 12,
        name: "Melawi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 166,
        state_id: 12,
        name: "Mempawah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 167,
        state_id: 12,
        name: "Pontianak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 168,
        state_id: 12,
        name: "Sambas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 169,
        state_id: 12,
        name: "Sanggau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 170,
        state_id: 12,
        name: "Sekadau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 171,
        state_id: 12,
        name: "Singkawang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 172,
        state_id: 12,
        name: "Sintang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 173,
        state_id: 13,
        name: "Balangan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 174,
        state_id: 13,
        name: "Banjarbaru",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 175,
        state_id: 13,
        name: "Banjarmasin",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 176,
        state_id: 13,
        name: "Barito Kuala",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 177,
        state_id: 13,
        name: "Hulu Sungai Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 178,
        state_id: 13,
        name: "Hulu Sungai Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 179,
        state_id: 13,
        name: "Hulu Sungai Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 180,
        state_id: 13,
        name: "Kotabaru",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 181,
        state_id: 13,
        name: "Tabalong",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 182,
        state_id: 13,
        name: "Tanah Bumbu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 183,
        state_id: 13,
        name: "Tanah Laut",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 184,
        state_id: 13,
        name: "Tapin",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 185,
        state_id: 14,
        name: "Barito Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 186,
        state_id: 14,
        name: "Barito Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 187,
        state_id: 14,
        name: "Barito Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 188,
        state_id: 14,
        name: "Gunung Mas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 189,
        state_id: 14,
        name: "Kapuas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 190,
        state_id: 14,
        name: "Katingan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 191,
        state_id: 14,
        name: "Kotawaringin Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 192,
        state_id: 14,
        name: "Kotawaringin Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 193,
        state_id: 14,
        name: "Lamandau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 194,
        state_id: 14,
        name: "Murung Raya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 195,
        state_id: 14,
        name: "Palangka Raya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 196,
        state_id: 14,
        name: "Pulang Pisau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 197,
        state_id: 14,
        name: "Seruyan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 198,
        state_id: 14,
        name: "Sukamara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 199,
        state_id: 15,
        name: "Balikpapan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 200,
        state_id: 15,
        name: "Berau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 201,
        state_id: 15,
        name: "Bontang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 202,
        state_id: 15,
        name: "Kutai Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 203,
        state_id: 15,
        name: "Kutai Kartanegara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 204,
        state_id: 15,
        name: "Kutai Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 205,
        state_id: 15,
        name: "Mahakam Ulu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 206,
        state_id: 15,
        name: "Paser",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 207,
        state_id: 15,
        name: "Penajam Paser Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 208,
        state_id: 15,
        name: "Samarinda",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 209,
        state_id: 16,
        name: "Bulungan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 210,
        state_id: 16,
        name: "Malinau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 211,
        state_id: 16,
        name: "Nunukan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 212,
        state_id: 16,
        name: "Tana Tidung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 213,
        state_id: 16,
        name: "Tarakan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 214,
        state_id: 17,
        name: "Bangka",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 215,
        state_id: 17,
        name: "Bangka Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 216,
        state_id: 17,
        name: "Bangka Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 217,
        state_id: 17,
        name: "Bangka Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 218,
        state_id: 17,
        name: "Belitung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 219,
        state_id: 17,
        name: "Belitung Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 220,
        state_id: 17,
        name: "Pangkal Pinang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 221,
        state_id: 18,
        name: "Batam",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 222,
        state_id: 18,
        name: "Bintan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 223,
        state_id: 18,
        name: "Karimun",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 224,
        state_id: 18,
        name: "Kepulauan Anambas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 225,
        state_id: 18,
        name: "Lingga",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 226,
        state_id: 18,
        name: "Natuna",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 227,
        state_id: 18,
        name: "Tanjung Pinang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 228,
        state_id: 19,
        name: "Bandar Lampung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 229,
        state_id: 19,
        name: "Lampung Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 230,
        state_id: 19,
        name: "Lampung Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 231,
        state_id: 19,
        name: "Lampung Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 232,
        state_id: 19,
        name: "Lampung Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 233,
        state_id: 19,
        name: "Lampung Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 234,
        state_id: 19,
        name: "Mesuji",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 235,
        state_id: 19,
        name: "Metro",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 236,
        state_id: 19,
        name: "Pesawaran",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 237,
        state_id: 19,
        name: "Pesisir Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 238,
        state_id: 19,
        name: "Pringsewu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 239,
        state_id: 19,
        name: "Tanggamus",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 240,
        state_id: 19,
        name: "Tulang Bawang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 241,
        state_id: 19,
        name: "Tulang Bawang Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 242,
        state_id: 19,
        name: "Way Kanan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 243,
        state_id: 20,
        name: "Ambon",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 244,
        state_id: 20,
        name: "Buru",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 245,
        state_id: 20,
        name: "Buru Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 246,
        state_id: 20,
        name: "Kepulauan Aru",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 247,
        state_id: 20,
        name: "Kepulauan Tanimbar (Maluku Tenggara Barat)",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 248,
        state_id: 20,
        name: "Maluku Barat Daya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 249,
        state_id: 20,
        name: "Maluku Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 250,
        state_id: 20,
        name: "Maluku Tenggara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 251,
        state_id: 20,
        name: "Seram Bagian Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 252,
        state_id: 20,
        name: "Seram Bagian Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 253,
        state_id: 20,
        name: "Tual",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 254,
        state_id: 21,
        name: "Halmahera Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 255,
        state_id: 21,
        name: "Halmahera Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 256,
        state_id: 21,
        name: "Halmahera Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 257,
        state_id: 21,
        name: "Halmahera Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 258,
        state_id: 21,
        name: "Halmahera Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 259,
        state_id: 21,
        name: "Kepulauan Sula",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 260,
        state_id: 21,
        name: "Pulau Morotai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 261,
        state_id: 21,
        name: "Pulau Taliabu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 262,
        state_id: 21,
        name: "Ternate",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 263,
        state_id: 21,
        name: "Tidore Kepulauan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 264,
        state_id: 22,
        name: "Bima",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 265,
        state_id: 22,
        name: "Dompu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 266,
        state_id: 22,
        name: "Lombok Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 267,
        state_id: 22,
        name: "Lombok Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 268,
        state_id: 22,
        name: "Lombok Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 269,
        state_id: 22,
        name: "Lombok Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 270,
        state_id: 22,
        name: "Mataram",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 271,
        state_id: 22,
        name: "Sumbawa",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 272,
        state_id: 22,
        name: "Sumbawa Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 273,
        state_id: 23,
        name: "Alor",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 274,
        state_id: 23,
        name: "Belu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 275,
        state_id: 23,
        name: "Ende",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 276,
        state_id: 23,
        name: "Flores Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 277,
        state_id: 23,
        name: "Kupang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 278,
        state_id: 23,
        name: "Lembata",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 279,
        state_id: 23,
        name: "Malaka",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 280,
        state_id: 23,
        name: "Manggarai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 281,
        state_id: 23,
        name: "Manggarai Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 282,
        state_id: 23,
        name: "Manggarai Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 283,
        state_id: 23,
        name: "Nagekeo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 284,
        state_id: 23,
        name: "Ngada",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 285,
        state_id: 23,
        name: "Rote Ndao",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 286,
        state_id: 23,
        name: "Sabu Raijua",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 287,
        state_id: 23,
        name: "Sikka",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 288,
        state_id: 23,
        name: "Sumba Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 289,
        state_id: 23,
        name: "Sumba Barat Daya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 290,
        state_id: 23,
        name: "Sumba Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 291,
        state_id: 23,
        name: "Sumba Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 292,
        state_id: 23,
        name: "Timor Tengah Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 293,
        state_id: 23,
        name: "Timor Tengah Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 294,
        state_id: 24,
        name: "Asmat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 295,
        state_id: 24,
        name: "Biak Numfor",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 296,
        state_id: 24,
        name: "Boven Digoel",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 297,
        state_id: 24,
        name: "Deiyai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 298,
        state_id: 24,
        name: "Dogiyai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 299,
        state_id: 24,
        name: "Intan Jaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 300,
        state_id: 24,
        name: "Jayapura",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 301,
        state_id: 24,
        name: "Jayawijaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 302,
        state_id: 24,
        name: "Keerom",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 303,
        state_id: 24,
        name: "Kepulauan Yapen",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 304,
        state_id: 24,
        name: "Lanny Jaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 305,
        state_id: 24,
        name: "Mamberamo Raya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 306,
        state_id: 24,
        name: "Mamberamo Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 307,
        state_id: 24,
        name: "Mappi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 308,
        state_id: 24,
        name: "Merauke",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 309,
        state_id: 24,
        name: "Mimika",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 310,
        state_id: 24,
        name: "Nabire",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 311,
        state_id: 24,
        name: "Nduga",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 312,
        state_id: 24,
        name: "Paniai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 313,
        state_id: 24,
        name: "Pegunungan Bintang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 314,
        state_id: 24,
        name: "Puncak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 315,
        state_id: 24,
        name: "Puncak Jaya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 316,
        state_id: 24,
        name: "Sarmi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 317,
        state_id: 24,
        name: "Supiori",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 318,
        state_id: 24,
        name: "Tolikara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 319,
        state_id: 24,
        name: "Waropen",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 320,
        state_id: 24,
        name: "Yahukimo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 321,
        state_id: 24,
        name: "Yalimo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 322,
        state_id: 25,
        name: "Fakfak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 323,
        state_id: 25,
        name: "Kaimana",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 324,
        state_id: 25,
        name: "Manokwari",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 325,
        state_id: 25,
        name: "Manokwari Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 326,
        state_id: 25,
        name: "Maybrat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 327,
        state_id: 25,
        name: "Pegunungan Arfak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 328,
        state_id: 25,
        name: "Raja Ampat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 329,
        state_id: 25,
        name: "Sorong",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 330,
        state_id: 25,
        name: "Sorong Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 331,
        state_id: 25,
        name: "Tambrauw",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 332,
        state_id: 25,
        name: "Teluk Bintuni",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 333,
        state_id: 25,
        name: "Teluk Wondama",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 334,
        state_id: 26,
        name: "Bengkalis",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 335,
        state_id: 26,
        name: "Dumai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 336,
        state_id: 26,
        name: "Indragiri Hilir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 337,
        state_id: 26,
        name: "Indragiri Hulu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 338,
        state_id: 26,
        name: "Kampar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 339,
        state_id: 26,
        name: "Kepulauan Meranti",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 340,
        state_id: 26,
        name: "Kuantan Singingi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 341,
        state_id: 26,
        name: "Pekanbaru",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 342,
        state_id: 26,
        name: "Pelalawan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 343,
        state_id: 26,
        name: "Rokan Hilir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 344,
        state_id: 26,
        name: "Rokan Hulu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 345,
        state_id: 26,
        name: "Siak",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 346,
        state_id: 27,
        name: "Majene",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 347,
        state_id: 27,
        name: "Mamasa",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 348,
        state_id: 27,
        name: "Mamuju",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 349,
        state_id: 27,
        name: "Mamuju Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 350,
        state_id: 27,
        name: "Pasangkayu (Mamuju Utara)",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 351,
        state_id: 27,
        name: "Polewali Mandar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 352,
        state_id: 28,
        name: "Bantaeng",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 353,
        state_id: 28,
        name: "Barru",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 354,
        state_id: 28,
        name: "Bone",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 355,
        state_id: 28,
        name: "Bulukumba",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 356,
        state_id: 28,
        name: "Enrekang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 357,
        state_id: 28,
        name: "Gowa",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 358,
        state_id: 28,
        name: "Jeneponto",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 359,
        state_id: 28,
        name: "Kepulauan Selayar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 360,
        state_id: 28,
        name: "Luwu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 361,
        state_id: 28,
        name: "Luwu Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 362,
        state_id: 28,
        name: "Luwu Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 363,
        state_id: 28,
        name: "Makassar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 364,
        state_id: 28,
        name: "Maros",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 365,
        state_id: 28,
        name: "Palopo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 366,
        state_id: 28,
        name: "Pangkajene Kepulauan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 367,
        state_id: 28,
        name: "Parepare",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 368,
        state_id: 28,
        name: "Pinrang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 369,
        state_id: 28,
        name: "Sidenreng Rappang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 370,
        state_id: 28,
        name: "Sinjai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 371,
        state_id: 28,
        name: "Soppeng",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 372,
        state_id: 28,
        name: "Takalar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 373,
        state_id: 28,
        name: "Tana Toraja",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 374,
        state_id: 28,
        name: "Toraja Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 375,
        state_id: 28,
        name: "Wajo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 376,
        state_id: 29,
        name: "Banggai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 377,
        state_id: 29,
        name: "Banggai Kepulauan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 378,
        state_id: 29,
        name: "Banggai Laut",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 379,
        state_id: 29,
        name: "Buol",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 380,
        state_id: 29,
        name: "Donggala",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 381,
        state_id: 29,
        name: "Morowali",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 382,
        state_id: 29,
        name: "Morowali Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 383,
        state_id: 29,
        name: "Palu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 384,
        state_id: 29,
        name: "Parigi Moutong",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 385,
        state_id: 29,
        name: "Poso",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 386,
        state_id: 29,
        name: "Sigi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 387,
        state_id: 29,
        name: "Tojo Una-Una",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 388,
        state_id: 29,
        name: "Toli-Toli",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 389,
        state_id: 30,
        name: "Bau-Bau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 390,
        state_id: 30,
        name: "Bombana",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 391,
        state_id: 30,
        name: "Buton",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 392,
        state_id: 30,
        name: "Buton Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 393,
        state_id: 30,
        name: "Buton Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 394,
        state_id: 30,
        name: "Buton Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 395,
        state_id: 30,
        name: "Kendari",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 396,
        state_id: 30,
        name: "Kolaka",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 397,
        state_id: 30,
        name: "Kolaka Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 398,
        state_id: 30,
        name: "Kolaka Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 399,
        state_id: 30,
        name: "Konawe",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 400,
        state_id: 30,
        name: "Konawe Kepulauan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 401,
        state_id: 30,
        name: "Konawe Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 402,
        state_id: 30,
        name: "Konawe Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 403,
        state_id: 30,
        name: "Muna",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 404,
        state_id: 30,
        name: "Muna Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 405,
        state_id: 30,
        name: "Wakatobi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 406,
        state_id: 31,
        name: "Bitung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 407,
        state_id: 31,
        name: "Bolaang Mongondow",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 408,
        state_id: 31,
        name: "Bolaang Mongondow Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 409,
        state_id: 31,
        name: "Bolaang Mongondow Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 410,
        state_id: 31,
        name: "Bolaang Mongondow Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 411,
        state_id: 31,
        name: "Kepulauan Sangihe",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 412,
        state_id: 31,
        name: "Kepulauan Siau Tagulandang Biaro (Sitaro)",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 413,
        state_id: 31,
        name: "Kepulauan Talaud",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 414,
        state_id: 31,
        name: "Kotamobagu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 415,
        state_id: 31,
        name: "Manado",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 416,
        state_id: 31,
        name: "Minahasa",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 417,
        state_id: 31,
        name: "Minahasa Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 418,
        state_id: 31,
        name: "Minahasa Tenggara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 419,
        state_id: 31,
        name: "Minahasa Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 420,
        state_id: 31,
        name: "Tomohon",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 421,
        state_id: 32,
        name: "Agam",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 422,
        state_id: 32,
        name: "Bukittinggi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 423,
        state_id: 32,
        name: "Dharmasraya",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 424,
        state_id: 32,
        name: "Kepulauan Mentawai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 425,
        state_id: 32,
        name: "Lima Puluh Kota",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 426,
        state_id: 32,
        name: "Padang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 427,
        state_id: 32,
        name: "Padang Panjang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 428,
        state_id: 32,
        name: "Padang Pariaman",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 429,
        state_id: 32,
        name: "Pariaman",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 430,
        state_id: 32,
        name: "Pasaman",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 431,
        state_id: 32,
        name: "Pasaman Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 432,
        state_id: 32,
        name: "Payakumbuh",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 433,
        state_id: 32,
        name: "Pesisir Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 434,
        state_id: 32,
        name: "Sawah Lunto",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 435,
        state_id: 32,
        name: "Sijunjung",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 436,
        state_id: 32,
        name: "Solok",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 437,
        state_id: 32,
        name: "Solok Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 438,
        state_id: 32,
        name: "Tanah Datar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 439,
        state_id: 33,
        name: "Banyuasin",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 440,
        state_id: 33,
        name: "Empat Lawang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 441,
        state_id: 33,
        name: "Lahat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 442,
        state_id: 33,
        name: "Lubuk Linggau",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 443,
        state_id: 33,
        name: "Muara Enim",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 444,
        state_id: 33,
        name: "Musi Banyuasin",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 445,
        state_id: 33,
        name: "Musi Rawas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 446,
        state_id: 33,
        name: "Musi Rawas Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 447,
        state_id: 33,
        name: "Ogan Ilir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 448,
        state_id: 33,
        name: "Ogan Komering Ilir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 449,
        state_id: 33,
        name: "Ogan Komering Ulu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 450,
        state_id: 33,
        name: "Ogan Komering Ulu Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 451,
        state_id: 33,
        name: "Ogan Komering Ulu Timur",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 452,
        state_id: 33,
        name: "Pagar Alam",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 453,
        state_id: 33,
        name: "Palembang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 454,
        state_id: 33,
        name: "Penukal Abab Lematang Ilir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 455,
        state_id: 33,
        name: "Prabumulih",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 456,
        state_id: 34,
        name: "Asahan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 457,
        state_id: 34,
        name: "Batu Bara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 458,
        state_id: 34,
        name: "Binjai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 459,
        state_id: 34,
        name: "Dairi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 460,
        state_id: 34,
        name: "Deli Serdang",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 461,
        state_id: 34,
        name: "Gunungsitoli",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 462,
        state_id: 34,
        name: "Humbang Hasundutan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 463,
        state_id: 34,
        name: "Karo",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 464,
        state_id: 34,
        name: "Labuhanbatu",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 465,
        state_id: 34,
        name: "Labuhanbatu Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 466,
        state_id: 34,
        name: "Labuhanbatu Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 467,
        state_id: 34,
        name: "Langkat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 468,
        state_id: 34,
        name: "Mandailing Natal",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 469,
        state_id: 34,
        name: "Medan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 470,
        state_id: 34,
        name: "Nias",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 471,
        state_id: 34,
        name: "Nias Barat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 472,
        state_id: 34,
        name: "Nias Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 473,
        state_id: 34,
        name: "Nias Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 474,
        state_id: 34,
        name: "Padang Lawas",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 475,
        state_id: 34,
        name: "Padang Lawas Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 476,
        state_id: 34,
        name: "Padang Sidempuan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 477,
        state_id: 34,
        name: "Pakpak Bharat",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 478,
        state_id: 34,
        name: "Pematang Siantar",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 479,
        state_id: 34,
        name: "Samosir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 480,
        state_id: 34,
        name: "Serdang Bedagai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 481,
        state_id: 34,
        name: "Sibolga",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 482,
        state_id: 34,
        name: "Simalungun",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 483,
        state_id: 34,
        name: "Tanjung Balai",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 484,
        state_id: 34,
        name: "Tapanuli Selatan",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 485,
        state_id: 34,
        name: "Tapanuli Tengah",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 486,
        state_id: 34,
        name: "Tapanuli Utara",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 487,
        state_id: 34,
        name: "Tebing Tinggi",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
    {
        id: 488,
        state_id: 34,
        name: "Toba Samosir",
        createdAt: "2021-12-07 07:15:28",
        updatedAt: "2021-12-07 07:15:28",
    },
];